import React, { useEffect, useState } from 'react'
import './Graf.css'
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import fetchData from '../../function/fetchData';
import { useNavigate } from 'react-router-dom';
import CloseButton from 'react-bootstrap/CloseButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { setWeek } from 'date-fns';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


  
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Global +',
      },
    },
  };


const Graf = ({server}) => {
  const navigate = useNavigate();
  const [token, setToken] = useState(null)
  const [dataFromServer ,setDataFromServer] = useState([])
  const [selectedWeek, setSelectedWeek] = useState(0)

      // Má data v localstorage?
    useEffect( () => {
        const data = localStorage.getItem('driverToken');
        console.log(data)
        if(data) {
          setToken(data)
        }
    }, [])

  const data = {
    labels: ['Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota', 'Neděle'],
    datasets: [
      {
        label: 'Prohlíželi',
        backgroundColor: 'rgba(75,192,192,1)',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 8,
        hoverBackgroundColor: 'rgba(75,192,192,0.4)',
        hoverBorderColor: 'rgba(75,192,192,1)',
        data: dataFromServer?.visitsCount,
      },
      {
        label: 'Objedali',
        backgroundColor: '#940042',
        borderColor: '#940042',
        borderWidth: 8,
        hoverBackgroundColor: '#940042',
        hoverBorderColor: '#940042',
        data: dataFromServer?.tripsCount,
      },
      {
        label: 'Registrace',
        backgroundColor: '#F2EDA7',
        borderColor: '#F2EDA7',
        borderWidth: 8,
        hoverBackgroundColor: '#F2EDA7',
        hoverBorderColor: '#F2EDA7',
        data: dataFromServer?.usersCount,
      },
    ],
  };

  useEffect( ()=> {
    if(token){
      fetchData(server + 'api2/chartController.php' , {token, action: 'SHOW', week: selectedWeek})
      .then( (res) => setDataFromServer(res.payload))
    }
    
  },[token, selectedWeek])

  return (
     <div>

      <div className='top'>
                <div style={{display:'flex', gap: 10, alignItems: 'center'}}>
                <h2>Týdenní vývoj</h2>
                <ToggleButtonGroup type="radio" name="options" defaultValue={1} size={'sm'}>
                    <ToggleButton id="tbg-radio-4" value={4} onClick={()=>setSelectedWeek(-3)}>
                    Tři týdny zpět
                    </ToggleButton>

                  <ToggleButton id="tbg-radio-3" value={3} onClick={()=>setSelectedWeek(-2)}>
                   Dva týdny zpět
                  </ToggleButton>
                  
                  <ToggleButton id="tbg-radio-2" value={2} onClick={()=>setSelectedWeek(-1)}>
                    Jeden týden zpět
                  </ToggleButton>

                  <ToggleButton id="tbg-radio-1" value={1} onClick={()=>setSelectedWeek(0)}>
                    Tento týden
                  </ToggleButton>

              </ToggleButtonGroup>
                </div>
               
                <CloseButton onClick={()=> navigate('/admin') }/>
      </div>
      <div style={{padding:50, height: 500}}>
        <Line data={data} options={options} />
      </div>
      
    </div>
  )
}

export default Graf
